if (!customElements.get('aramse-pour-tip')) {
  customElements.define('aramse-pour-tip', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panel = this.querySelector('.sf-pour-tip');
      if (!this.panel) return;
      this.abort = new AbortController();
      const on = (el, type, fn) => el.addEventListener(type, fn, {signal:this.abort.signal});
      this.querySelectorAll('.sf-recipe-body').forEach(body => {
        const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) {
          if (/Aramse Pour/i.test(walker.currentNode.data) && !walker.currentNode.parentElement.closest('button,a')) nodes.push(walker.currentNode);
        }
        nodes.forEach(node => {
          const fragment = document.createDocumentFragment();
          node.data.split(/(Aramse Pour)/gi).forEach(part => {
            if (!/^Aramse Pour$/i.test(part)) { fragment.append(document.createTextNode(part)); return; }
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'sf-pour-trigger'; button.textContent = part;
            button.setAttribute('aria-controls', this.panel.id); button.setAttribute('aria-expanded', 'false');
            on(button, 'pointerenter', e => { if (e.pointerType === 'mouse') this.open(button); });
            on(button, 'pointerleave', () => this.later());
            on(button, 'focus', () => this.open(button));
            on(button, 'click', () => this.open(button));
            on(button, 'blur', () => this.later());
            fragment.append(button);
          });
          node.replaceWith(fragment);
        });
      });
      on(this.panel, 'pointerenter', () => clearTimeout(this.timer));
      on(this.panel, 'pointerleave', () => this.later());
      on(this.panel, 'focusin', () => clearTimeout(this.timer));
      on(this.panel, 'focusout', () => this.later());
      on(this.panel.querySelector('.sf-pour-close'), 'click', () => this.close());
      on(this.panel, 'toggle', () => {
        if (!this.panel.matches(':popover-open')) this.querySelectorAll('.sf-pour-trigger').forEach(b => b.setAttribute('aria-expanded','false'));
      });
      on(window, 'resize', () => this.close());
      on(document, 'scroll', () => { if (this.panel.matches(':popover-open')) this.position(); });
      this.querySelectorAll('.sf-recipe').forEach(d => on(d, 'toggle', () => { if (!d.open && d.contains(this.trigger)) this.close(); }));
    }
    open(button) {
      clearTimeout(this.timer);
      this.trigger = button;
      this.querySelectorAll('.sf-pour-trigger').forEach(b => b.setAttribute('aria-expanded',String(b === button)));
      if (!this.panel.matches(':popover-open')) this.panel.showPopover();
      this.position();
    }
    position() {
      const r = this.trigger.getBoundingClientRect(), p = this.panel.getBoundingClientRect();
      const h = window.innerHeight, w = window.innerWidth;
      const top = r.bottom + p.height + 12 <= h ? r.bottom + 8 : r.top - p.height - 8;
      this.panel.style.left = Math.max(12, Math.min(r.left, w - p.width - 12)) + 'px';
      this.panel.style.top = Math.max(12, Math.min(top, h - p.height - 12)) + 'px';
    }
    later() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (!this.panel.matches(':hover') && !this.panel.contains(document.activeElement) && document.activeElement !== this.trigger) this.close();
      }, 180);
    }
    close() { clearTimeout(this.timer); if (this.panel.matches(':popover-open')) this.panel.hidePopover(); }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.ready = false; }
  });
}
